<template>
    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="headline" style="width:94%;text-align:start">Rename</span>
            <div style="position: relative;inset-inline-start:4%;bottom: 3px;"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30"  @click="closeDialog()" fill="currentColor" class="bi bi-x close-icon" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
          </svg></div>
          </v-card-title>
          <v-card-text>
            <v-container>
              <div class="modal-body">
                <input type="text" @keyup.enter="renameFolderOrFileAction()" ref="folderNameField" v-if="show" class="bg-transparent border rounded text-light form-control input-fields" v-model="folderName">
              </div>
            </v-container>
          </v-card-text>
          <v-card-actions class="primary-btn-style">
            <button @click="closeDialog()" data-dismiss="modal" class="btn btn-outline-secondary mr-2">Cancel</button>
            <button class="btn btn-outline-primary ml-1" @click="renameFolderOrFileAction()">
            Save
          </button>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
</template>


<script>
import {mapActions} from "vuex";
import Utils from "../../components.utils.js";

export default {
  props:["fileInfo"],
  data: () => ({
    dialog: true,
    folderName:"",
    selectedFileInfo:null,
    show:false,
    extension:""
  }),
  methods:{
      closeDialog(){
          this.$emit("close")
      },
      renameFolderOrFileAction(){
        const validation = Utils.isSafeFolderOrFileName(this.folderName);
        if (!validation.valid) {
          alert(validation.message);
          this.$refs.folderNameField.focus();
          return;
        }
        let payload = {};
        payload._id = this.selectedFileInfo._id;
        payload.job_name = "Rename";
        payload.size = this.selectedFileInfo.size;
        payload.file_uid = this.selectedFileInfo.file_uid;
        payload.asset_id = this.selectedFileInfo.asset_id;
        if(this.selectedFileInfo.file_type == "file"){
          payload.element_type = "file";
          this.extension = "." + String(this.selectedFileInfo.path.substr(this.selectedFileInfo.path.lastIndexOf('.') + 1)).toLowerCase()
        }else{
          payload.element_type = "folder";
          this.extension = "";
        }
        payload.path = this.selectedFileInfo.path;
        if(this.folderName == null || this.folderName.length == 0){
             alert("Rename field is empty");
             return false;
        }else if(Object.keys(this.selectedFileInfo).includes('parent_path') && this.selectedFileInfo != undefined && this.selectedFileInfo.parent_path != undefined){
          payload.dst_path = this.selectedFileInfo.parent_path + "/" + this.folderName + this.extension;
          payload.src_path = this.selectedFileInfo.path;
        }
        this.renameFolderOrFile(payload).then((data)=>{
          console.log("[Rename] Data is : ",data)
          if (Utils.isAcceptedStatusCode(data.statusCode)) {
                if (data.message.includes("Failed")) {
                    this.$toast.warning(data.message);
                } else {
                    this.$toast.success(data.message);
                }
                } else {
                this.$toast.error(data.message);
                }
        });
        this.closeDialog();
      },
    ...mapActions("actions", ["renameFolderOrFile"]),
  },
   watch: {
    'show': function (val) {
      if (val) {
          this.$nextTick(() => {
          this.$refs.folderNameField.focus()
        })
      }
    }
  },
  mounted(){
    setTimeout(() => {
      this.show = true;
    }, 200)
  },
  created(){
      this.selectedFileInfo = this.fileInfo;
      if(this.fileInfo.file_type == "file"){
        this.folderName = this.fileInfo.file_name;
        this.folderName = this.folderName.split('.').slice(0, -1).join('.')
      }else{
        this.folderName = Utils.getBaseName(this.fileInfo.path);
        this.folderName = this.folderName.split('.').slice(0, -1).join('.')
      }
  }
}
</script>

<style lang="scss" scoped>

  $border-color: 1px solid #4a4a4a;
  $border-color-only:#4a4a4a;
  $primary-background: #1a1e21;
  $secondary-background-color:#15181B;
  $bg-color-on-hover: #22272b;
  $text-color: #eee;
  $dull-text-color: #757575;
  $secondary-text-color: #9c9c9c;
  $active-blue : #007bff;
  $input-field-and-label-font-size:14px;
  $danger-color: #dc3545 !important;
  $input-field-height:38px;
  $none-text-color:#4f4f4f;
  $input-field-padding:.375rem 10px;
  $scrollbar-thumb-background:#333;
  $scrollbar-track-background:#1a1e21;
  $scrollbar-thumb-on-hover-background:#555;
  $tags-background-color:#282d31;
  $tags-border-color:#363636;
  $metadata-border-color-on-hover: #5a5a5a;
  $secondary-border-color: 1px solid #2b2b2b;
  $active-green-color:#28a745;
  $svg-color:#666;
  $learn-about-text-color-hover:#b7b327;
  $active-green-icon-color: #00ff3a;
  $learn-about-text-color:#9a9620;
  $icon-hover:#2c3339;

::v-deep{
    .v-btn{
      text-transform: inherit;
    }
    .v-card__title, .v-card__actions{
        background: $secondary-background-color !important;
        padding:8px;
        border-bottom: $secondary-border-color;
    }
    .v-card__text{
        background: $primary-background !important;
    }

    .v-card__actions{
        border-top: $secondary-border-color;
    }

    .save-btn.v-btn--outlined {
        border: thin solid #007bff;
    }

    .theme--dark.v-btn.v-btn--outlined.v-btn--text {
        border-color: #007bff;
    }

    .v-card.v-sheet.theme--dark{
        border: $secondary-border-color;
    }

    .v-text-field__slot{
        margin-inline-start:-10px;
    }
     .v-text-field {
        input {
                margin-inline-start: 12px;
                margin-top: 16px;
                color:$text-color
        }
     }
}

svg{
    fill:$svg-color;
}

.primary-btn-style {
  justify-content: flex-end;
  margin-top: 1%;
  height:55px;
  button {
    height: 35px;
    width: 70px;
    border-radius: 5px;
    font-size:14px;
  }
}
.secondary-btn-style:hover {
    text-decoration: underline;
}

.input-fields {
  border: none !important;
  border-bottom: 1px solid #007bff !important;
  height:30px;
}

.input-fields:focus {
  outline: unset;
  box-shadow:none;
}
.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
  fill:$text-color;
}
</style>